export const C = { forest: "#085041", mint: "#2EC48A", gold: "#C9A84C", ivory: "#FBF8F1", ink: "#0F172A" };

export const PageSheet = ({ src, w, x, y, rot = 0, z = 1, tag = "br" }) => (
  <div
    className="absolute bg-white"
    style={{
      left: x, top: y, width: w, height: Math.round(w * 1.4142), zIndex: z,
      transform: `rotate(${rot}deg)`, transformOrigin: "50% 60%",
      boxShadow: "0 1px 2px rgba(8,80,65,.06), 0 18px 40px -12px rgba(8,80,65,.28)",
      borderRadius: 3, overflow: "hidden",
    }}
  >
    <img src={src} alt="" className="block w-full h-full" style={{ objectFit: "cover" }} draggable={false} />
    {tag && (
      <span
        className="absolute"
        style={{
          ...(tag === "tl" ? { left: 8, top: 8 } : { right: 8, bottom: 8 }), fontSize: 8, fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase",
          color: "#94A3B8", background: "rgba(255,255,255,.9)", border: "1px solid #EEF2F6",
          padding: "1px 6px", borderRadius: 999, fontFamily: "Inter, sans-serif",
        }}
      >
        Ejemplo
      </span>
    )}
  </div>
);

export const Caption = ({ x, y, children, color = C.forest, align = "left", w = 220 }) => (
  <div
    className="absolute"
    style={{ left: x, top: y, width: w, textAlign: align, fontFamily: "Inter, sans-serif", fontSize: 12, fontWeight: 600, color }}
  >
    {children}
  </div>
);

export const Pill = ({ children, gold }) => (
  <span
    style={{
      display: "inline-block", fontFamily: "Inter, sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: ".1em",
      textTransform: "uppercase", padding: "5px 11px", borderRadius: 999,
      color: gold ? "#6B5316" : C.forest, background: gold ? "#F6EDD3" : "#E3F6EE",
    }}
  >
    {children}
  </span>
);

export const Heading = ({ title, subtitle, price, size = 40, children }) => (
  <div style={{ fontFamily: "Outfit, sans-serif" }}>
    <div className="flex items-center gap-2.5 mb-5">
      <span style={{ width: 28, height: 2, background: C.gold, display: "inline-block" }} />
      <span style={{ fontFamily: "Inter, sans-serif", fontSize: 12, letterSpacing: ".22em", textTransform: "uppercase", color: C.forest, fontWeight: 600 }}>
        OptimizaRRHH
      </span>
    </div>
    <h2 style={{ fontSize: size, lineHeight: 1.08, fontWeight: 700, color: C.forest, letterSpacing: "-0.02em", margin: 0 }}>{title}</h2>
    <p style={{ fontFamily: "Inter, sans-serif", fontSize: Math.round(size * 0.4), color: "#475569", margin: "14px 0 0", lineHeight: 1.45, textAlign: "left" }}>{subtitle}</p>
    <div className="flex items-center gap-3" style={{ marginTop: 22 }}>
      <span style={{ fontSize: Math.round(size * 0.7), fontWeight: 700, color: C.ink }}>{price}</span>
      {children}
    </div>
  </div>
);

export const Canvas = ({ w, h, children, innerRef }) => (
  <div
    ref={innerRef}
    className="relative overflow-hidden"
    style={{ width: w, height: h, background: `radial-gradient(120% 90% at 85% 40%, #FFFFFF 0%, ${C.ivory} 62%)` }}
  >
    <div className="absolute" style={{ left: 0, right: 0, bottom: 0, height: 5, background: `linear-gradient(90deg, ${C.forest}, ${C.mint})` }} />
    {children}
    <div
      className="absolute"
      style={{ right: 28, bottom: 18, fontFamily: "Inter, sans-serif", fontSize: 12, color: "#64748B", letterSpacing: ".02em" }}
    >
      talenthealthcheck.com
    </div>
  </div>
);
